import { useAuthStore } from '@/store/auth';
import { getAuthEpoch } from '@/utils/authEpoch';
import { ticketRecoveryOwner } from '@/utils/ticketRecovery';

/** Remount every ticket editor after its author or sign-in session changes. */
export function useTicketSessionKey(): string {
  return useAuthStore((state) => `${ticketRecoveryOwner(state.user) ?? ''}:${getAuthEpoch()}`);
}
